export const QA_NAME_CALENDAR_TASK_REQUEST_LINK = 'calendarTaskRequestLink'
